module.exports = "<div class=\"navbar\">\n  <div class=\"title\">\n    <div>taxihandgo</div><div>pec+</div>\n  </div>\n\n  <a *ngIf=\"tracesUrl\" [href]=\"tracesUrl\" target=\"_blank\">Récupérer les traces anonymes</a>\n</div>\n\n<div class=\"content\">\n  <taxihandgo-patient [patient]=\"patient\" *ngFor=\"let patient of patientsManager.patients\"></taxihandgo-patient>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.html
// module id = 491
// module chunks = 1